import React from "react";

const Partners = () => {
  const partners = [
    { name: "AWS", img: "/assets/images/partners/aws.png" },
    { name: "Microsoft", img: "/assets/images/partners/micro.png" },
    { name: "Google", img: "/assets/images/partners/Google.png" },
        { name: "Odoo", img: "/assets/images/partners/odoo.png" },
            { name: "Boomi", img: "/assets/images/partners/boomi.png" },

  ];

  return (
    <section className="bg-gray-50 py-16 border border-box">
      <div className="container mx-auto px-6">
        {/* --- Heading --- */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 tracking-tight">
            Partnering with Industry Leaders
          </h2>
          <div className="w-24 h-1 bg-black mx-auto mt-4 mb-6"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-800 mb-12">
            We collaborate with globally recognized technology partners to deliver
            high-performance solutions.
          </p>
        </div>

        {/* --- Logos --- */}
        <div className="flex flex-wrap justify-center gap-10 md:gap-16 lg:gap-20 items-center">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="group flex justify-center items-center w-38 md:w-42 lg:w-46 transition-transform duration-300 hover:scale-110"
            >
              <img
                src={partner.img}
                alt={`${partner.name} Logo`}
                className="max-h-16 object-contain transition duration-300 ease-in-out"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
